import { lazy, Suspense } from "react";
import MainLayout from "../layout";
import routeConstants from "../utils/routeConstants";
import AuthGuard from "./AuthGuards";
import LoadingFallback from "../components/common/LoadingFallback";

// Lazy load all page components
const Dashboard = lazy(() => import("../pages/Dashboard"));
const Profile = lazy(() => import("../pages/Profile"));
const Campaigns = lazy(() => import("../pages/Campaigns"));
const Insights = lazy(() => import("../pages/Insights"));
const ManageDataSource = lazy(() => import("../pages/ManageDataSource"));
const Reports = lazy(() => import("../pages/Reports"));
const SendFeedback = lazy(() => import("../pages/SendFeedback"));
const Conversions = lazy(() => import("../pages/Conversions"));
const AdCopies = lazy(() => import("../pages/AdCopies"));
const ComingInFuture = lazy(() => import("../pages/ComingInFuture"));

// Lazy load component-level routes
const CampaignDetails = lazy(() => import("../components/campaign/CampaignDetails"));
const AddFormContainer = lazy(() => import("../components/conversions/AddFormContainer"));
const ConversionAccountDetails = lazy(() => import("../components/conversions/ConversionAccountDetails"));
const ConversionDetails = lazy(() => import("../components/conversions/ConversionDetails"));
const EditFormContainer = lazy(() => import("../components/conversions/EditFormContainer"));
const GeneratedReport = lazy(() => import("../components/reports/generatedReportSection"));
const ReportsDetailSection = lazy(() => import("../components/reports/reportsDetailSection"));
const TopRecommendedDetailsReport = lazy(() => import("../components/reports/reportsDetailSection/topRecommendedReports/TopRecommendedDetailsReport"));

const MainRoutes = {
  path: "/",
  element: (
    <AuthGuard>
      <Suspense fallback={<LoadingFallback />}>
        <MainLayout />
      </Suspense>
    </AuthGuard>
  ),
  children: [
    {
      path: routeConstants.dashboard,
      element: <Dashboard />,
    },
    {
      path: routeConstants.myProfile,
      element: <Profile />,
    },
    {
      path: routeConstants.campaigns,
      element: <Campaigns />,
    },
    {
      path: routeConstants.insights,
      element: <Insights />,
    },
    {
      path: routeConstants.manageDataSource,
      element: <ManageDataSource />,
    },
    {
      path: routeConstants.reports,
      element: <ReportsDetailSection />,
    },
    {
      path: routeConstants.generateReports,
      element: <Reports />,
    },
    {
      path: routeConstants.generatedReport + "/:id",
      element: <GeneratedReport />,
    },
    {
      path: routeConstants.topRecommendedDetailsReport + "/:type",
      element: <TopRecommendedDetailsReport />,
    },
    {
      path: routeConstants.campaignDetails + "/:id",
      element: <CampaignDetails />,
    },
    // {
    //   path: routeConstants.privacyPolicy,
    //   element: <PrivacyPolicy />,
    // },
    // {
    //   path: routeConstants.aboutUs,
    //   element: <AboutUs />,
    // },
    // {
    //   path: routeConstants.learnAboutTrialPartners,
    //   element: <LearnAboutTrialPartners />,
    // },
    {
      path: routeConstants.sendFeedback,
      element: <SendFeedback />,
    },
    {
      path: routeConstants.conversions,
      element: <Conversions />,
    },
    {
      path: routeConstants.conversionsAddForm,
      element: <AddFormContainer />,
    },
    {
      path: routeConstants.conversionsUpdateForm + "/:id",
      element: <EditFormContainer />,
    },
    {
      path: routeConstants.conversionAccountDetails + "/:id",
      element: <ConversionAccountDetails />,
    },
    {
      path: routeConstants.conversionDetails + "/:id",
      element: <ConversionDetails />,
    },
    {
      path: routeConstants.adCopies,
      element: <AdCopies />,
    },
    {
      path: "*",
      element: <ComingInFuture />,
    },
  ],
};

export default MainRoutes;
